class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      if (!event.target.classList.contains('gift-wrap-checkbox')) {
        this.onChange(event);
      }
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.addEventListener('pageshow', this.refresh(this));

    if (document.querySelectorAll('.quantity-limit-enabled').length) {
      this.handleQuantityLimits();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.max);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        section: 'header',
        selectors: '#cart-icon-bubble'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  renderContents(parsedState, animateInClass) {
    if (!parsedState.sections) {
      return console.error('No sections in state', parsedState);
    }

    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

      if (!elementToReplace) {
        return;
      }

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector, animateInClass);

      elementToReplace.querySelectorAll('.hide-to-animate').forEach(el => {
        el.classList.add('fade-in');
        el.addEventListener('animationend', () => {
          el.classList.remove('fade-in');
        }, { once: true });
        window.requestAnimationFrame(() => el.classList.remove('hide-to-animate'));
      });
    });

    let cartAdditionalData = document.querySelector('.cart-additional-data');
    const sessionCartAdditionalData = sessionStorage.getItem('cart-additional');

    if (cartAdditionalData && sessionCartAdditionalData) {
      cartAdditionalData.innerHTML = sessionCartAdditionalData;
    }

    this.updateEmptyState(parsedState);
    if (window.Nosto) {
      Nosto.reloadCart(["cart-upsell"])
    }
  }

  updateQuantity(line, quantity, name, max) {
    this.enableLoading(line);

    if (max != null && max.length && Number(quantity) > Number(max)) {
      quantity = max;
    };

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const giftWrapLineItem = document.querySelector(`#CartDrawer-Item-${line} .gift-wrap-form--attached`);
    const mainCart = document.getElementById('main-cart-items')

    let giftWrapIndex = 0;

    if (giftWrapLineItem) {
      giftWrapIndex = giftWrapLineItem.dataset.index;

      if (quantity === 0) {
        this.handleAssociatedGiftWrapProduct(giftWrapIndex, quantity);
      }
    }

    fetch('/cart/change.js', { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('fostr-cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (section.hasOwnProperty('selectors')) {
              const selector = section.selectors;
              const elementToReplace = document.querySelector(selector);
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);

          } else {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.updateLiveRegions(line, parsedState.item_count, parsedState.items_removed);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        if (giftWrapIndex > 0 && quantity !== 0) {
          const key = parsedState.items[line - 1].key;
          const properties = {
              ...parsedState.items[giftWrapIndex - 1].properties,
              "_gift_wrap_key": `${key}`
            };
          this.handleAssociatedGiftWrapProduct(giftWrapIndex, quantity, properties);
        } else {
          this.disableLoading();
        }

        if (window.Nosto) {
          Nosto.reloadCart(["cart-upsell"])
        }

        if (mainCart) {
          this.handleQuantityLimits();
        }
        return parsedState;
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount, itemsRemoved) {
    if (this.currentItemCount === itemCount && itemsRemoved.length < 1) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      let errorMsg = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );

      if (lineItemError.dataset.hasIndividualLimit) {
        errorMsg = window.cartStrings.quantityErrorIndividual.replace(
          '[quantity]',
          quantityElement.value
        )
      }

      lineItemError.querySelector('.cart-item__error-text').innerHTML = errorMsg;
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('fostr-cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.remove('cart__items--disabled');
  }

  refresh(event) {
    if (event.persisted) {
      window.location.reload();
    }

    const perfEntries = performance.getEntriesByType('navigation');
    if (perfEntries.length && perfEntries[0].type === 'back_forward') {

      const body = JSON.stringify({
        line: 0,
        quantity: 0
      });
      fetch('/cart/update.js', { ...fetchConfig(), ...{ body } });
    }
  };

  handleQuantityLimits() {
    const quantitiesByVariant = {};

    // Step 1: Gather totals per variant
    this.querySelectorAll('.quantity__input').forEach((quantityInput) => {
      const key = quantityInput.dataset.key;
      const quantity = Number(quantityInput.value);
      const max = Number(quantityInput.max);
      const variantId = quantityInput.dataset.quantityVariantId;

      // Combine quantities for the same variant
      if (!quantitiesByVariant[variantId]) {
        quantitiesByVariant[variantId] = { total: 0, keys: [], max: max };
      }
      quantitiesByVariant[variantId].total += quantity;
      quantitiesByVariant[variantId].keys.push(key);
    });

    // Step 2: Apply restrictions where needed
    for (const variantId in quantitiesByVariant) {
      const { total, max, keys } = quantitiesByVariant[variantId];

      const pdpBtns = document.querySelectorAll(`[data-variant-id-atc="${variantId}"]`)

      if (max && total >= max) {
        if (pdpBtns) {
          pdpBtns.forEach(btn => {
            btn.setAttribute('data-max-reached', 'true');
          });
        }

        // Find all matching inputs and set max to their current value
        const inputs = this.querySelectorAll(`input[data-quantity-variant-id="${variantId}"]`);
        inputs.forEach(input => {
          input.max = input.value; // lock it to current quantity
          input.readOnly = true;
          input.addEventListener('keydown', (e) => e.preventDefault()); // block typing
        });

      } else {
        if (pdpBtns) {
          pdpBtns.forEach(btn => btn.setAttribute('data-max-reached', 'false'));
        }
      }
    }
  }

  handleAssociatedGiftWrapProduct(line, quantity, properties = {}) {

    const body = JSON.stringify({
      line,
      quantity,
      properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch('/cart/change.js', { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('fostr-cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (section.hasOwnProperty('selectors')) {
              const selector = section.selectors;
              const elementToReplace = document.querySelector(selector);
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);

          } else {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.updateLiveRegions(line, parsedState.item_count, parsedState.items_removed);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading();

      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch('/cart/update.js', { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
}